<app-svg src="/assets/icons/16/alert.svg" class="alert-icon" [appTooltip]="warningMessage" *ngIf="warningMessage">
</app-svg>

<app-context-menu [options]="{ width: '260px', noSpacing: true }" #menu>
  <button
    appButton
    name="access-toggle"
    location="gallery-share-context"
    data-test-id="access-toggle"
    class="email-access-toggle"
    [class.center-vertically]="centerVertically"
    [color]="disabled ? 'simple-gray' : red ? 'simple-warn' : 'simple-primary'"
    weight="bold"
    [disabled]="disabled"
    [hasIcon]="true"
    spacing="1"
    height="1"
    contextButton
  >
    <span>{{ accessLevel | accessLevel }}</span>
    <app-svg src="/assets/icons/24/arrow-down.svg" size="-1"></app-svg>
  </button>
  <div contextContent class="button-menu" *ngIf="!disabled">
    <app-button-menu-item
      *ngFor="let al of accessLevels; let i = index"
      name="access-{{ mode }}-{{ al }}"
      location="gallery-share-context"
      [color]="accessLevel === al ? 'simple-primary' : al === 'remove' || al === 'leave' ? 'simple-warn' : 'simple'"
      (onClick)="onChange.emit(al); menu.close()"
      [fullWidth]="true"
      [height]="alDescription[al] ? '3' : '2'"
      [attr.data-test-id]="'access-level_' + al"
      [class.last]="i === accessLevels.length - 1 && i !== 0"
    >
      <div>
        <strong>{{ al | accessLevel }}</strong>
        <span class="action-description">{{ alDescription[al] }}</span>
      </div>
    </app-button-menu-item>
  </div>
</app-context-menu>
